import { ApiClient, PagedResults, ServiceResponse } from "../../../common";
import { PlatformSettings } from "../../../settings/platformSettings";
import { CompanySearchParameters } from "../../dtos/in/company/companySearchParameters";
import { AddressDto } from "../../dtos/out/addressDto";
import { AddressSearchResultsDto } from "../../dtos/out/addressSearchResultsDto";
import { CompanyInformationDto } from "../../dtos/out/companyInformationDto";
import { CompanySearchCandidateDto } from "../../dtos/out/companySearchCandidateDto";
import { CrmQueueDto } from "../../dtos/out/crmQueueDto";
import { LocationDto } from "../../dtos/out/locationDto";
import { ILookupsClient } from "../interfaces/lookupsClient";


class LookupsClient extends ApiClient implements ILookupsClient {

    private _baseUrl: string;
    constructor(private platformSettings: PlatformSettings) {
        super();
        this._baseUrl = platformSettings.apiUrl + "/lookups";
    }

    get baseUrl(): string {
        return this._baseUrl;
    }

    public async getAddressById(addressId: string, accessToken: string): Promise<ServiceResponse<AddressDto>> {
        return await super.Get<AddressDto>(this.baseUrl, `addresses?addressId=${encodeURIComponent(addressId)}`, accessToken);
    }

    public async searchAddressesAsync(partial: string, countryCode: string = "GB", accessToken: string): Promise<ServiceResponse<AddressSearchResultsDto>> {
        return await super.Get<AddressSearchResultsDto>(this.baseUrl, `addresses/search-results?partial=${encodeURIComponent(partial)}&countryCode=${countryCode}`, accessToken);
    }

    public async getAddressesByContainerId(addressId: string, accessToken: string): Promise<ServiceResponse<AddressSearchResultsDto>> {
        return await super.Get<AddressSearchResultsDto>(this.baseUrl, `containers/search-results?containerId=${encodeURIComponent(addressId)}`, accessToken);
    }

    public async searchCompaniesAsync(companySearchParameters: CompanySearchParameters, page: number, pageSize: number, accessToken: string): Promise<ServiceResponse<PagedResults<CompanySearchCandidateDto>>>
    {
        let resourceUrl = `companies/search-results?page=${page}&pageSize=${pageSize}`;

        Object.keys(companySearchParameters).filter((key) => {
            if (companySearchParameters[key] !== "" && companySearchParameters[key] !== null &&  companySearchParameters[key] !== undefined)
            {
                resourceUrl += `&${key}=${encodeURIComponent(companySearchParameters[key])}`;
            }
        });

        var results = await super.Get<PagedResults<CompanySearchCandidateDto>>(this.baseUrl, resourceUrl, accessToken);
        return results;
    }

    public async getCompanyAsync(dunsNumber: number, accessToken: string): Promise<ServiceResponse<CompanyInformationDto>> {
        return await super.Get<CompanyInformationDto>(this.baseUrl, `companies/${dunsNumber}`, accessToken);
    }

    public async getCrmQueues(accessToken: string): Promise<ServiceResponse<CrmQueueDto[]>> {
        return await super.Get<CrmQueueDto[]>(this.baseUrl, `crm-queues`, accessToken);
    }

    public async getCrmPartnerQueues(partnerId: string, accessToken: string): Promise<ServiceResponse<CrmQueueDto[]>> {
        return await super.Get<CrmQueueDto[]>(this.baseUrl, `partners/${partnerId}/crm-queues`, accessToken);
    }

    public async getLocation(address: string, accessToken: string): Promise<ServiceResponse<LocationDto>> {
        return await super.Get<LocationDto>(this.baseUrl, `locations?address=${address}`, accessToken);
    }

}

export { LookupsClient }